<template>
  <PageHeading
    :has-meta-data="false"
    :has-action-button="true"
    :has-search="true"
    :title="$t('Expert stats')"
    @open="this.openForm = !this.openForm"
    @update:search="search = $event"
    :hasSearch="true"
  />
  <div class="">
    <h1 class="sr-only">Account Settings</h1>
    <header class="border-b w-full">
      <!-- Secondary navigation -->
      <!-- <nav class="flex overflow-x-auto py-4 max-w-5xl mx-auto">
        <ul
          role="list"
          class="flex flex-none gap-x-6 px-4 text-sm font-semibold leading-6 text-gray-700 sm:px-6 lg:px-8 items-center"
        >
          <li v-for="item in navigation" :key="item.name">
            <router-link
              :to="`/expert-statistics/configuration/${item.href}`"
              :class="[
                item.current ? 'text-white bg-teal-600' : '',
                'px-2 py-1 rounded-lg hover:bg-teal-600 hover:text-white',
              ]"
              >{{ $t(item.name) }}</router-link
            >
          </li>
        </ul>
      </nav> -->
    </header>
    <div class="mx-auto divide-y divide-white/5 pb-5">
      <Pbx3cxReportsList :key="search" :search="search" />
    </div>
  </div>
  <ask-confirmation-dialog
    ref="askConfirmationDialog"
  ></ask-confirmation-dialog>
</template>

<script>
import PageHeading from "../../components/PageHeading.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import AskConfirmationDialog from "../../components/AskConfirmationDialog.vue";
import Pbx3cxReportsList from "../../components/PBX/Pbx3cxReportsList.vue";

export default {
  props: ["menu", "getPbxHosts"],
  components: {
    PageHeading,
    AskConfirmationDialog,
    Pbx3cxReportsList,
  },
  data() {
    return {
      search: "",
    };
  },
  methods: {},
  mounted() {},
  computed: {
    ...mapGetters([
      "hostNames",
      "hostName",
      "user",
      "pbx3cxCustomerCode",
      "pbx3cxTableConfig",
      "pbx3cxAgentConfig",
      "pbxMap",
      "pbxElements",
      "groupSelected",
      "groupSelectedName",
    ]),
  },
};
</script>

<style></style>
